import {ErrorObject} from 'types';
import {toast} from 'react-toastify';
import isError from 'helpers/isError';

/**
 * This function will determine if there is an error in the request.
 * @param {T | ErrorObject} response
 * @return {boolean}
 */
export default function validateResponse<T>(
    response: T | ErrorObject,
): boolean {
  if (!isError(response)) return true;

  const messages: string[] = Array.isArray(response.message) ? [
    ...response.message,
  ] : [response.message];

  messages.forEach((message) => {
    toast.error(message);
  });

  return false;
}
